<template>
  <div id="mail-modal" class="modal" v-show="modalShown">
    <div class="modal-main" id="mail-main">
      <div class="cross_btn" @click="close()">
        <span class="css-cancel"></span>
      </div>
      <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。"/>
      <button type="submit" class="main_btn" @click="inviteUser()">招待する</button>
      <div class="error_message">{{ errors.email }}</div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as Check from '../../../utils/Check'
import * as App from '../../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'estimateModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      mailAddress: '',
      errors: {},
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      modalShown: true,
      submitDisable: false
    }
  },
  methods: {
    close: function () {
      this.modalShown = false
    },
    inviteUser: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }

      let payload = {
        mailAddress: this.mailAddress
      }
      axios.post(DC_URL.USER + '/invitation', payload)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
            App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
            App.showModal({
              messages: ['招待メールを送信しました。']
            })
          }
        }).catch(error => {
          this.errorMessage.text = error.response.data.errorMessage
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#mail-main {
  height: 80px;
  input {
    width: 240px;
  }
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/InviteUserModal.vue